import React, { Component } from 'react';

class ClientSlider extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
     
        }
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        window.contentWayPoint();
        window.playVideo();
    }
  
    componentWillUnmount() {
    }

    render() {

        return (
            <div>
                <div className="client-slider owl-carousel owl-custom-nav">
                    {                                                
                        this.props.clients.length > 0 && this.props.clients.map((client, key) => (
                            <div key={key} className="post-thumbnail ftco-animate " data-animate-effect="fadeIn">
                                <div className="">
                                    <div dangerouslySetInnerHTML={{__html: client.title}} className="ft-18 mb-4 client-title"></div>
                                </div>
                                <div className="mt-4" dangerouslySetInnerHTML={{__html: client.description}}>
                                </div>
                            </div>
                        ))
                    }
                </div>
                
            </div>
        );
    }
}

export default ClientSlider;